// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

import { getFirestore } from "firebase/firestore"
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCxQlrxSaf5RlAR48nG9CEMsTP6ZD5v5Wo",
    authDomain: "chartercommittee-dfaa3.firebaseapp.com",
    projectId: "chartercommittee-dfaa3",
    storageBucket: "chartercommittee-dfaa3.appspot.com",
    messagingSenderId: "787812111469",
    appId: "1:787812111469:web:08ac8eff84d679046edb64",
    measurementId: "G-6EZ6XSQGG7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

export const fireStore = getFirestore();
export const auth = getAuth();
export const functions = getFunctions();
export const storage = getStorage();
